module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1003-071740fae295918ae1fb236af2af4ad8.png";